import React, { useState, useEffect, useContext } from 'react';
import Logo from '../assets/images/ipad.png';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import 'animate.css';

export default function Home() {
  


    return (
        <>
            <main className="Home">
                <section style={{ gap: "5em" }}>

                    <article>

                        <h1 className="text-6xl font-bold">Welcome to Children's Hospital Portal!</h1>

                      
                
                    </article>
                    <article>
                        <img src={Logo} className="logo" />
                    </article>
                </section>
            </main>
        </>
    )
}
